<script>
    import ResultItem from "./result/ResultItem.svelte";
    import Pagination from "./result/Pagination.svelte";
    import { query, searchResult } from "../libs/stores";
    import OPTS from "../libs/options"

    function changePage(event) {
        query.setPage(event.detail.page);
    }
</script>

<div class="o-block-container">
    <div class="o-container--inner">
        <div class="c-results">
            <div class="c-results__header">
                <h3 class="c-results__number">{($searchResult.total).toLocaleString('it-IT')} risultati trovati</h3>
            </div>
            <div class="c-results__body">
                {#if $searchResult.total}
                    {#each $searchResult.docs as item (item.id)}
                        <ResultItem {...item} />
                    {/each}
                {:else}
                    <p>Nessun elemento trovato</p>
                {/if}
            </div>
            {#if $searchResult.total > 12}
                <Pagination perpage={OPTS.page_size} total={$searchResult.total} current_page={$query.page} on:change-page={changePage} />
            {/if}
        </div>
    </div>
</div>
